import React, { useContext} from "react";
import { Header, Footer } from "../../Components";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../../Context";
import { LOGIN } from "../../routes";

const Layout = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const isLoggedIn = Boolean(user)

  if (!isLoggedIn && location !== LOGIN) {
    return <Navigate to={LOGIN} />;
  }

  return (
    <div className="min-h-[100dvh] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <header className="sticky top-[env(safe-area-inset-top)] z-50 bg-white h-16">
        <Header />
      </header>
      <div>
        <main
          className="overflow-y-auto"
          style={{ height: "calc(100dvh - 5rem)" }}
        >
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );

};

export default Layout;
